module.exports = __webpack_public_path__ + "img/portrett.7f931b6d.png";